<template>
    <div id="level-form">
        <v-card v-for="kelasItem in kelasList" :key="kelasItem.kelas" flat class="mb-5">
            <!-- Header -->
            <v-card-actions>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">Kelas</v-list-item-title>
                        <v-text-field :value="kelasItem.kelas" outlined disabled filled />
                    </v-list-item-content>
                </v-list-item>
                <v-spacer></v-spacer>
                <v-btn icon @click="kelasItem.show = !kelasItem.show">
                    <v-icon>{{ kelasItem.show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
            </v-card-actions>

            <!-- Expand -->
            <v-expand-transition>
                <div v-show="kelasItem.show" class="mx-5">
                    <v-divider></v-divider>

                    <!-- Loop levels -->
                    <div v-for="(level, levelIndex) in kelasItem.levels" :key="levelIndex" class="mt-5">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold pb-2">Level</v-list-item-title>
                                <v-text-field :value="level.value" outlined disabled filled />
                            </v-list-item-content>
                        </v-list-item>

                        <!-- Input row -->
                        <v-row dense>
                            <v-col cols="6">
                                <v-text-field v-model="level.min_poin" type="number" label="Minimal Poin" outlined />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="level.max_poin" type="number" label="Maksimal Poin" outlined
                                    :disabled="level.value === 'Gold'" />
                            </v-col>
                        </v-row>

                        <v-divider v-if="levelIndex < kelasItem.levels.length - 1"></v-divider>
                    </div>

                    <!-- Save button -->
                    <v-card-actions class="mb-2">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="submitLevel(kelasItem.kelas, kelasItem.levels)">
                            Simpan Level Kelas {{ kelasItem.kelas }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-expand-transition>
        </v-card>

        <app-spinner v-if="isLoading" />
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

const baseLevels = [
    { id: 1, level_id: 0, value: "No Rank", min_poin: 1, max_poin: 0 },
    { id: 2, level_id: 0, value: "Beginner", min_poin: 0, max_poin: 0 },
    { id: 3, level_id: 0, value: "Silver", min_poin: 0, max_poin: 0 },
    { id: 4, level_id: 0, value: "Bronze", min_poin: 0, max_poin: 0 },
    { id: 5, level_id: 0, value: "Gold", min_poin: 0, max_poin: 99000 }
];

export default {
    name: "level-editform",
    components: { "app-spinner": Spinner },

    data() {
        return {
            isLoading: false,
            periode_id: this.$route.query.id,
            kelasList: Array.from({ length: 9 }, (_, i) => ({
                kelas: i + 4,
                show: false,
                levels: JSON.parse(JSON.stringify(baseLevels)) // deep copy
            }))
        };
    },

    mounted() {
        if (this.periode_id) {
            this.getDetailLevel();
        }
    },

    methods: {
        getDetailLevel() {
            this.isLoading = true;

            AmbisMeterService.getLevelDetail(this.periode_id, (response) => {
                if (response && response.success) {
                    const fetched = response.data;
                    const desiredOrder = ["Beginner", "Bronze", "Silver", "Gold"];

                    this.kelasList.forEach((kelasItem) => {
                        const match = fetched.find(f => f.kelas === kelasItem.kelas);
                        if (match) {
                            kelasItem.levels = kelasItem.levels.map(baseLevel => {
                                const found = match.levels.find(lvl => lvl.level_id === baseLevel.id);
                                return {
                                    ...baseLevel,
                                    level_id: found ? found.id : 0,
                                    min_poin: found && found.min_poin !== undefined ? found.min_poin : baseLevel.min_poin,
                                    max_poin: found && found.max_poin !== undefined ? found.max_poin : baseLevel.max_poin
                                };
                            });

                            // remove No Rank and sort by order
                            kelasItem.levels = kelasItem.levels
                                .filter(lvl => lvl.value !== "No Rank")
                                .sort((a, b) => desiredOrder.indexOf(a.value) - desiredOrder.indexOf(b.value));
                        }
                    });
                } else {
                    this.$store.commit("showAlert", {
                        message: "Gagal ambil data level!",
                        type: "error"
                    });
                }
                this.isLoading = false;
            });
        },

        submitLevel(kelas, levels) {
            const arrayLevel = levels.map(lvl => ({
                id: lvl.level_id && lvl.level_id !== 0 ? lvl.level_id : null, // null if not yet created
                periode_id: this.$store.state.ambismeter.id,
                kelas,
                level_id: lvl.id,
                min_poin: parseFloat(lvl.min_poin) || 0,
                max_poin: parseFloat(lvl.max_poin) || 0
            }));

            this.isLoading = true;

            // Check if any level already exists (has real backend id)
            const hasExisting = arrayLevel.some(l => l.id !== null && l.id !== 0);

            if (hasExisting) {
                // Update existing levels
                AmbisMeterService.updateLevel(this.periode_id, kelas, arrayLevel, (result) => {
                    this.$store.commit("showAlert", {
                        message: result.success
                            ? `Level Kelas ${kelas} berhasil diperbarui!`
                            : "Gagal update level!",
                        type: result.success ? "success" : "error"
                    });
                    this.isLoading = false;
                });
            } else {
                // Create new levels
                AmbisMeterService.addLevel(arrayLevel, (result) => {
                    this.$store.commit("showAlert", {
                        message: result.success
                            ? `Level Kelas ${kelas} berhasil dibuat!`
                            : "Gagal membuat level!",
                        type: result.success ? "success" : "error"
                    });
                    this.isLoading = false;
                });
            }
        }

    }
};
</script>



// WEBPACK FOOTER //
// LevelEditForm.vue?3fc1692c